import * as methods from '../methods';
import { Resource } from '../Resource';
const rootPath = 'forecasts';
const fromRaw = {
    getForecasts: (raw) => raw,
    getWeatherModel: (raw) => {
        return raw.map((r) => {
            return {
                modelId: r.model_id,
                start: r.start,
                end: r.end
            };
        });
    }
};
const forecasts = Resource((requesterBuilder) => {
    const getForecasts = (query) => methods.get({
        requesterBuilder,
        rootPath: `${rootPath}/${query?.plotId ? 'plots' : 'devices'}`,
        fromRaw: fromRaw.getForecasts,
        params: {
            query: {
                plot: query?.plotId,
                device: query?.deviceId,
                since: query?.since,
                before: query?.before,
                span: query?.span,
                measurements: query?.metrics,
                unitOfTime: query?.unitOfTime
            }
        }
    })();
    return {
        /** Will parse return into an array of object that includes all metrics and the timestamp rather than having to work with the Forecasts object */
        getForecastsAsArray: (params) => {
            const result = {
                invalidationKey: ['forecasts'],
                key: [
                    `history_${'plotId' in params ? params.plotId : 'deviceId' in params ? params.deviceId : ''}_${params.since}_${params.before}_${params.span}_${params.metrics.join(',')}${'unitOfTime' in params ? `_${params.unitOfTime}` : ''}`
                ],
                fetchAndTransform: () => {
                    throw new Error('not implemented');
                },
                request: async () => {
                    const requester = getForecasts(params);
                    const data = await requester.request();
                    return Object.entries(data).reduce((acc, [key, timestampValueRecord], index) => {
                        const m = key;
                        // Filling the array on the first loop
                        if (index === 0) {
                            Object.entries(timestampValueRecord).forEach(([ts, value]) => {
                                acc.push({ timestamp: parseInt(ts, 10), [m]: value });
                            });
                        }
                        // Finding the matching object and completing it for the rest of the loops
                        else {
                            Object.entries(timestampValueRecord).forEach(([ts, value]) => {
                                const existing = acc.find((obj) => obj.timestamp === parseInt(ts, 10));
                                if (existing)
                                    existing[m] = value;
                            });
                        }
                        return acc;
                    }, []);
                }
            };
            return result;
        },
        getForecasts,
        /** TODO: Rename as it returns time frames of weather models for a specific location, and not only weather models */
        getWeatherModel: (query) => methods.get({
            requesterBuilder,
            rootPath: `${rootPath}/models`,
            fromRaw: fromRaw.getWeatherModel,
            params: {
                query: {
                    lat: query?.lat,
                    lng: query?.lng
                }
            }
        })()
    };
});
export default forecasts;
